module.exports = __webpack_public_path__ + "media/images/icons/inbox-10987a5a003b53b632a89053b9f2812b.svg";